import { put, call } from "redux-saga/effects";
import log from "loglevel";
import * as services from "./service";
import * as t from "./types";
import * as actions from "./action";
import { toastr } from "react-redux-toastr";

export function* decodeJwtSaga(action: t.DecodeJwtActionType) {
  try {
    const response = yield call(services.decodeJwtService);
    yield put({ type: actions.DECODE_JWT_SUCCESS, response });
  } catch (error) {
    yield put({ type: actions.DECODE_JWT_ERROR, response: error });
  }
}

export function* refreshJwtSaga(action: t.RefreshJwtActionType) {
  try {
    const response = yield call(services.refreshJwtService);
    if (response.data) {
      yield put({ type: actions.REFRESH_JWT_SUCCESS, response });
    } else {
      throw response;
    }
  } catch (error) {
    yield put({ type: actions.REFRESH_JWT_ERROR, response: error });
  }
}
